module.exports = __webpack_public_path__ + "static/media/Mark_Moskowitz.70c0e331.png";